var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, DialogActions, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom-v5-compat";
import { ActionTypes } from "../../OrderFlow/OrderFlowProvider/OrderFlowActionTypes";
import { ModalContent, useModal } from "../../Shared/components/Modal";
import Stack from "@mui/material/Stack";
import { DeliverySectionText } from "./DeliveryMethodSection-types";
import { tokenReplace } from "../../Shared/utils/tokenReplacement";
import { useCompany } from "../../Shared/components/CompanyProvider/CompanyProvider";
export const useShowDeliveryScheduleWarningModal = () => {
    const { showModal, closeModal } = useModal();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    const navigate = useNavigate();
    const { tokenMap } = useCompany();
    return {
        showDeliveryScheduleWarningModal: ((newAddressData, nextLocation, flowSku, isDeliveryAddressNewlyEntered, newDeliveryScheduleId) => {
            //Address id will be defined if switching from a pick up location to a delivery address
            //isDeliveryAddressNewlyEntered flag is for Addresses entered in <NeedsAddress> component.
            //We're prompting user before saving the address so there's no ID to check against
            const fromPickupToDelivery = !!(newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.address_id);
            showModal({
                title: DeliverySectionText.DELIVERY_SCHEDULE_WARNING_TITLE,
                content: (_jsx(ModalContent, { children: _jsxs(Stack, Object.assign({ spacing: 1 }, { children: [_jsx(Typography, { children: fromPickupToDelivery || isDeliveryAddressNewlyEntered
                                    ? DeliverySectionText.DELIVERY_SCHEDULE_ADDRESS_WARNING
                                    : DeliverySectionText.DELIVERY_SCHEDULE_LOCATION_WARNING }), _jsx(Typography, { children: fromPickupToDelivery || isDeliveryAddressNewlyEntered
                                    ? tokenReplace(DeliverySectionText.ADDRESS_SELECT_CONFIRM, false, tokenMap)
                                    : tokenReplace(DeliverySectionText.LOCATION_SELECT_CONFIRM, false, tokenMap) }), _jsx(Typography, { children: fromPickupToDelivery || isDeliveryAddressNewlyEntered
                                    ? DeliverySectionText.ADDRESS_SELECT_CANCEL
                                    : DeliverySectionText.LOCATION_SELECT_CANCEL })] })) })),
                actions: (_jsxs(DialogActions, { children: [_jsx(Button, Object.assign({ size: "medium", variant: "outlined", color: "secondary", fullWidth: true, onClick: () => closeModal() }, { children: DeliverySectionText.CANCEL })), _jsx(Button, Object.assign({ size: "medium", variant: "contained", color: "secondary", fullWidth: true, onClick: () => {
                                //Restart Order Flow with the new location or postalCode
                                if (!newDeliveryScheduleId) {
                                    navigate(`/${flowSku}/OrderFlow`, {
                                        replace: true,
                                        state: {
                                            location: undefined,
                                            postalCode: undefined
                                        },
                                    });
                                }
                                else {
                                    navigate(`/${flowSku}/OrderFlow`, {
                                        replace: true,
                                        state: {
                                            location: fromPickupToDelivery ? undefined : nextLocation,
                                            postalCode: fromPickupToDelivery || isDeliveryAddressNewlyEntered ? newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.zip : undefined,
                                        },
                                    });
                                }
                                closeModal();
                            } }, { children: DeliverySectionText.CONFIRM }))] })),
                fullScreen: isMobile,
            });
        }),
    };
};
export const updateLocationFunction = (setValue, clearErrors, closeModal, toast, location, locations, dispatch, setLoading, setIsModalOpen, navigate) => (newAddressData) => __awaiter(void 0, void 0, void 0, function* () {
    setLoading(true);
    //Address id will be defined if switching from a pick up location to a delivery address
    const fromPickupToDelivery = !!newAddressData.address_id;
    if (!!newAddressData.address_id) {
        location.state.postalCode = newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.zip;
        location.state.addressId = +(newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.address_id);
        location.state.location = undefined;
        dispatch({ type: ActionTypes.SET_POSTAL_CODE, payload: newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.zip });
        dispatch({ type: ActionTypes.SET_LOCATION, payload: undefined });
        setValue("address", +newAddressData.address_id);
        setValue("location", undefined);
        clearErrors("address");
    }
    if (!!newAddressData.location_sku) {
        const newLocation = locations === null || locations === void 0 ? void 0 : locations.find((l) => l.locationSku === newAddressData.location_sku);
        location.state.postalCode = undefined;
        location.state.addressId = undefined;
        location.state.location = newLocation;
        dispatch({ type: ActionTypes.SET_LOCATION, payload: newLocation });
        dispatch({ type: ActionTypes.SET_POSTAL_CODE, payload: undefined });
        setValue("location", newAddressData.location_sku);
        setValue("address", undefined);
        clearErrors("location");
    }
    toast.push(fromPickupToDelivery ? DeliverySectionText.ADDRESS_UPDATE_SUCCESS : DeliverySectionText.LOCATION_UPDATE_SUCCESS, { variant: "success" });
    setLoading(false);
    closeModal();
    setIsModalOpen(false);
    navigate(`/${location.state.orderFlowState.sku}/Checkout`, { state: location.state });
});
